import Scriba from 'react-scriba';

export class DataSocieteAPI {

    static _chargementSocietesAPIs(filtres, sortedColumn, isSortedDescending) {
        const objet = { filtres, sortedColumn, isSortedDescending };
        const url = "api/Liste/ListeDesSocietesAPIs";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementSocieteAPI = (societeAPI) => {
        const url = "api/MAJDonnees/EnregistrementSociete_API";
        const paramPost = Scriba.fetch().createParameterPost(societeAPI);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementMultipleSocieteAPI = (idSociete, idsAPIs) => {
        const objet = { idSociete, idsAPIs };
        const url = "api/MAJDonnees/EnregistrementMultipleSociete_API";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionSocieteAPI = (idSociete, idAPI) => {
        const objet = { idAPI, idSociete };
        const url = "api/MAJDonnees/SuppressionSociete_API";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

}